import { render, staticRenderFns } from "./DuvidasFrequentes.vue?vue&type=template&id=79e98d87&scoped=true"
import script from "./DuvidasFrequentes.vue?vue&type=script&lang=js"
export * from "./DuvidasFrequentes.vue?vue&type=script&lang=js"
import style0 from "./DuvidasFrequentes.vue?vue&type=style&index=0&id=79e98d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e98d87",
  null
  
)

export default component.exports